jQuery(document).ready(function ($) {
    const offeringsSlider = new Swiper('.js-offerings', {
        loop: true,

        slidesPerView: 1,
        speed: 300,

        spaceBetween: 24,

        pagination: {
            el: '.js-offerings__pagination',
            type: 'bullets'
        },

        autoplay: {
            delay: 5000
        }
    });

    function toggleSliderAndGrid() {
        if ($(window).outerWidth() > 800) {
            $('.js-offerings').hide();
            $('.js-offerings-grid').show();
        } else {
            $('.js-offerings').show();
            $('.js-offerings-grid').hide();
        }
    }

    $(window).on('resize', function (event) {
        toggleSliderAndGrid();
    });

    toggleSliderAndGrid();
});